// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","content":"App_content__naSmy","footer":"App_footer__e+Tfn"};